import { useHistory, useRouteMatch } from "react-router-dom";
import { Button } from "../DesignSystem/Button/Button";
import Modal from "../DesignSystem/Modal/Modal";
import { useUpdateQuery } from "hooks/useQuery";

export const RegistrationTypeModal = ({
  open,
  onModalClose,
  stateId,
}: {
  open: boolean;
  onModalClose: () => void;
  stateOptions?: { label: string; value: string }[];
  stateId?: string;
}) => {
  const { path } = useRouteMatch();
  const { location, push } = useHistory();
  const { update } = useUpdateQuery();

  const updateQueryAndPush = (type: string) => {
    const currentParams = new URLSearchParams(location.search);
    currentParams.set("type", type);
    currentParams.set("state_id", stateId || "");
    push(`${path}/registrations?${currentParams.toString()}`);
  };

  const onAddNewRegistration = () => {
    if (location.pathname.includes("/registrations")) {
      update({ query: "type", value: "new" });
    } else {
      updateQueryAndPush("new");
    }
  };

  const onAddExistingRegistration = () => {
    if (location.pathname.includes("/registrations")) {
      update({ query: "type", value: "existing" });
    } else {
      updateQueryAndPush("existing");
    }
  };
  return (
    <Modal.Root open={open} onOpenChange={onModalClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Registration </Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-flex t-flex-col t-items-center t-gap-y-6 t-py-5">
            <Button
              onClick={onAddNewRegistration}
              className="t-text-text-100 t-text-body t-w-full t-bg-surface t-border-neutral-10 t-border-solid t-rounded-md t-border t-py-5"
            >
              Add a new registration
            </Button>
            <span className="t-text-text-black t-text-body-lg">or</span>
            <Button
              onClick={onAddExistingRegistration}
              className="t-text-text-100 t-text-body t-w-full t-bg-surface t-border-neutral-10 t-border-solid t-rounded-md t-border t-py-5"
            >
              Add an existing registration
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer className="t-pb-16" />
      </Modal.Content>
    </Modal.Root>
  );
};
